import { platformBrand } from './platform';
import { zuadariaBrand } from './zuadaria';
import { BRAND_HOST_MAP, isBrandKey, type BrandConfig, type BrandKey } from './types';

const REGISTRY: Record<BrandKey, BrandConfig> = {
  platform: platformBrand,
  zuadaria: zuadariaBrand,
};

export function getBrandConfig(key: BrandKey | string | null | undefined): BrandConfig {
  if (isBrandKey(key)) return REGISTRY[key];
  return platformBrand;
}

export function normalizeHost(hostname: string): string {
  return hostname.trim().toLowerCase().replace(/:\d+$/, '');
}

export type ResolveBrandInput = {
  hostname?: string;
  parishBrandKey?: string | null;
  publicBrandKey?: string | null;
  /** Legado: nome/slug ainda usado só como fallback até brandKey estar em todas as orgs. */
  legacyLabel?: string | null;
};

/**
 * Ordem fixa:
 * 1) REACT_APP_BRAND_FORCE
 * 2) host map
 * 3) parish.brandKey
 * 4) payload público brandKey
 * 5) legado label (aziadus/zuadaria) — temporário
 * 6) platform
 */
export function resolveBrandKey(input: ResolveBrandInput = {}): BrandKey {
  const forced = (process.env.REACT_APP_BRAND_FORCE || '').trim().toLowerCase();
  if (isBrandKey(forced)) return forced;

  const host =
    input.hostname ??
    (typeof window !== 'undefined' ? window.location.hostname : '');
  const fromHost = BRAND_HOST_MAP[normalizeHost(host)];
  if (fromHost) return fromHost;

  if (isBrandKey(input.parishBrandKey)) return input.parishBrandKey;
  if (isBrandKey(input.publicBrandKey)) return input.publicBrandKey;

  if (input.legacyLabel) {
    const n = input.legacyLabel.toLowerCase().replace(/[\s_-]+/g, '');
    if (n.includes('aziadus') || n.includes('zuadaria')) return 'zuadaria';
  }

  return 'platform';
}

export function resolveBrand(input: ResolveBrandInput = {}): BrandConfig {
  return getBrandConfig(resolveBrandKey(input));
}
